import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  vocabularyCta: {
    id: 'seo_blue_beetle_communicate_cta_3',
  },
  bottomSectionDescription: {
    id: 'seo_blue_beetle_communicate_bottom_section_description',
  },
  blueBeetleCommunicate: {
    id: 'seo_blue_beetle_communicate',
  },
  blueBeetleAllRightReserved: {
    id: 'seo_blue_beetle_all_rights_message',
  },
});

export const en = defineMessages({
  learningCta: {
    id: 'seo_blue_beetle_communicate_section_cta_en',
  },
  bottomSectionTitle: {
    id: 'seo_blue_beetle_communicate_bottom_section_title_en',
  },
});

export const en_us = defineMessages({
  learningCta: {
    id: 'seo_blue_beetle_communicate_section_cta_en_us',
  },
  bottomSectionTitle: {
    id: 'seo_blue_beetle_communicate_bottom_section_title_en_us',
  },
});

export const es = defineMessages({
  learningCta: {
    id: 'seo_blue_beetle_communicate_section_cta_es',
  },
  bottomSectionTitle: {
    id: 'seo_blue_beetle_communicate_bottom_section_title_es',
  },
});

export const es_mx = defineMessages({
  learningCta: {
    id: 'seo_blue_beetle_communicate_section_cta_es_mx',
  },
  bottomSectionTitle: {
    id: 'seo_blue_beetle_communicate_bottom_section_title_es_mx',
  },
});
